// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';
import { NeedMet } from './needMet.zod.ts';

export const ClientBriefAsset = zod.object({
  "how": zod.array(NeedMet),
  "kind": zod.string(),
  "maturity": zod.string(),
  "name": zod.string(),
  "tagline": zod.string()
});

export type ClientBriefAsset = zod.input<typeof ClientBriefAsset>;
export type ClientBriefAssetOutput = zod.output<typeof ClientBriefAsset>;
